export enum ForecastChunkStatusEnum {
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}
